window.addEventListener('DOMContentLoaded', function() {
   if (window.DCCOMLivePreview && window.DCCOMLivePreview.disableV2) return;
   var canvas = document.getElementById('renderCanvas');
   var preview = document.querySelector('ccm-live-preview-v3[data-surface="homepage"]');
   var previewMode = String(preview && preview.dataset.mode || 'off').toLowerCase();
   var previewV3OwnsHomepage = previewMode === 'on' || (
       previewMode === 'internal' && new URLSearchParams(window.location.search).get('preview_v3') === '1'
   );
   if (previewV3OwnsHomepage || !canvas || !window.BABYLON) return;
   var engine = new BABYLON.Engine(canvas, true);


   var createScene = function() {
       var scene = new BABYLON.Scene(engine);
       scene.clearColor = new BABYLON.Color4(0.07, 0.07, 0.07, 0).toLinearSpace();
       var canvas = scene.getEngine().getRenderingCanvas();



       var env = "https://cdn.shopify.com/s/files/1/0852/1030/0697/files/environment_2k.env?v=1714376246"
       var baseUrl = "";
       var crystal = "https://cdn.shopify.com/3d/models/3455c9c730bf1ae7/Crystal_box_1.glb";
       var engraving = "https://cdn.shopify.com/3d/models/f178cf8953fe79c7/engraving_1.glb";
       // var new_crystal = "https://cdn.shopify.com/3d/models/882d31a1fa7beda3/Crystal_prestige_1.glb";
       var new_engraving = "https://cdn.shopify.com/3d/models/f178cf8953fe79c7/engraving_1.glb";
       var bg_tex = "https://cdn.shopify.com/s/files/1/0852/1030/0697/files/bg_r.jpg?v=1714376246";
       var canvas = scene.getEngine().getRenderingCanvas();
       var isMeshLoaded = false;
       var isMeshLoaded2 = false;

       // Load the HDR environment texture
       //var hdrTexture = new BABYLON.HDRCubeTexture(hdr, scene, 512);
       //scene.environmentTexture = hdrTexture;

       var envTexture = BABYLON.CubeTexture.CreateFromPrefilteredData(env, scene);
       scene.environmentTexture = envTexture;

       var plane = BABYLON.MeshBuilder.CreatePlane("plane", {
           width: 30,
           height: 20
       }, scene);
       var bg_material = new BABYLON.StandardMaterial("bg_material", scene);
       plane.material = bg_material;
       //plane.layerMask = 2;
       bg_material.diffuseTexture = new BABYLON.Texture(bg_tex, scene);
       //plane.position.z = -2; // Move the plane behind
       //plane.rotation.y = Math.PI; // Rotate the plane 180 degrees
       //plane.rotation.z = Math.PI; // Rotate the plane 180 degrees


       // Set up camera
       var camera = new BABYLON.ArcRotateCamera("camera",
           Math.PI / 2, // Alpha: Rotate the camera 90 degrees around the Y axis to face the side of the scene
           Math.PI / 2 - BABYLON.Tools.ToRadians(20), // Beta: Set elevation angle to 90 degrees to ensure the camera is not looking from above or below, but directly at the side
           10, // Radius: Distance from the camera to the target point
           BABYLON.Vector3.Zero(), scene);
       camera.fov = BABYLON.Tools.ToRadians(35);
       camera.minZ = 0.1;
       camera.attachControl(canvas, true);
       //camera.wheelPrecision = 500;    



       // DO NOT DELETE, CAMERA USED FOR RADIUS CALCULATION BEFORE FLY IN ANIMATION
       var cameraClone = new BABYLON.ArcRotateCamera("cameraClone",
           camera.alpha, // Alpha
           camera.beta, // Beta
           camera.radius, // Radius
           camera.target.clone(), scene); // Ensure to clone the target if it might change
       cameraClone.fov = camera.fov;
       cameraClone.minZ = camera.minZ;
       cameraClone.attachControl(canvas, true); // Attach control to the same canvas
       cameraClone.lowerRadiusLimit = 14;
       cameraClone.upperRadiusLimit = 14;



       plane.parent = camera;
       plane.position = new BABYLON.Vector3(0, 0, 30); // Adjust the Z value as needed to place the plane in front of the camera



       // Variable to store the current radius limits
       var currentRadiusLimits = {
           lower: camera.lowerRadiusLimit,
           upper: camera.upperRadiusLimit
       };
       //remove!!!!!!!!!!!!!
       // Function to adjust camera's radius limits based on canvas size
       //function updateCameraRadiusLimits() {
       //  var minDimension = Math.min(canvas.width);
       // if (minDimension < 450) { // Assuming '450' as a threshold for mobile devices
       //    currentRadiusLimits.lower = 16;
       //   currentRadiusLimits.upper = 16;
       //} else {
       //    currentRadiusLimits.lower = 8;
       //    currentRadiusLimits.upper = 8;
       //}



       //console.log (canvas.width)
       //console.log (canvas.height)
       //console.log(minDimension)
       //};


       function setCameraRadiusLimits() {
           camera.lowerRadiusLimit = cameraClone.lowerRadiusLimit;
           camera.upperRadiusLimit = cameraClone.upperRadiusLimit;

       }



       //updateCameraRadiusLimits();
       //console.log('Updated lower limit:', camera.lowerRadiusLimit);




       let userInteracted = false;
       let idleRotationFunction = null;
       let interactionTimeout;

       // Function to start idle rotation of the camera with a delay
       function startIdleRotation() {
           // Only add a new idle rotation if there isn't one already
           if (!idleRotationFunction) {
               idleRotationFunction = scene.onBeforeRenderObservable.add(() => {
                   camera.alpha += -0.001; // Adjust rotation speed as needed
               });
           }
       }

       // Function to stop the idle rotation
       function stopIdleRotation() {
           if (idleRotationFunction) {
               scene.onBeforeRenderObservable.remove(idleRotationFunction);
               idleRotationFunction = null;
           }
       }

       // Resets the idle rotation restart timer to wait for inactivity before restarting
       function resetIdleRotationRestartTimer() {
           clearTimeout(interactionTimeout); // Clear any previous timeout to prevent multiple restarts
           interactionTimeout = setTimeout(() => {
               startIdleRotation();
           }, 8000); // 8 seconds delay before restarting rotation
       }

       // Setup interaction listeners
       function setupUserInteraction() {
           const canvas = scene.getEngine().getRenderingCanvas();

           // Start interaction - stop any idle rotation
           canvas.addEventListener('pointerdown', () => {
               userInteracted = true;
               stopIdleRotation();
               clearTimeout(interactionTimeout); // Cancel any pending restart of rotation
           });

           // End interaction - prepare to restart idle rotation
           canvas.addEventListener('pointerup', () => {
               userInteracted = false;
               resetIdleRotationRestartTimer(); // Wait for inactivity before restarting
           });

           // You might also want to handle touch events separately if pointer events are not sufficient
           canvas.addEventListener('touchstart', () => {
               userInteracted = true;
               stopIdleRotation();
               clearTimeout(interactionTimeout); // Cancel any pending restart of rotation
           });

           canvas.addEventListener('touchend', () => {
               userInteracted = false;
               resetIdleRotationRestartTimer(); // Wait for inactivity before restarting
           });
       }

       // Initialize user interaction setup and start the idle rotation
       setupUserInteraction();




       // Camera fly-in animation setup
       var flyInAnimation = new BABYLON.Animation("flyIn", "radius", 60, BABYLON.Animation.ANIMATIONTYPE_FLOAT, BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT);


       // Define an easing function (Cubic ease in/out)
       var ease = new BABYLON.CubicEase();
       ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);

       // Apply the easing function to the animation
       flyInAnimation.setEasingFunction(ease);

       // Ensure the animation array on the camera is initialized
       if (!camera.animations) {
           camera.animations = [];
       }




       // https://doc.babylonjs.com/api/classes/babylon.defaultrenderingpipeline
       var defaultPipeline = new BABYLON.DefaultRenderingPipeline(
           "DefaultRenderingPipeline",
           false, // is HDR?
           scene,
           scene.cameras
       );
       if (defaultPipeline.isSupported) {
           /* MSAA */
           defaultPipeline.samples = 4; // 1 by default
           /* imageProcessing */
           defaultPipeline.imageProcessingEnabled = true; //true by default
           if (defaultPipeline.imageProcessingEnabled) {
               defaultPipeline.imageProcessing.contrast = 1.2; // 1 by default
               defaultPipeline.imageProcessing.exposure = 1.4; // 1 by default
               /* color grading */
               defaultPipeline.imageProcessing.colorGradingEnabled = false; // false by default
               if (defaultPipeline.imageProcessing.colorGradingEnabled) {
                   // using .3dl (best) :
                   defaultPipeline.imageProcessing.colorGradingTexture = new BABYLON.ColorGradingTexture("textures/LateSunset.3dl", scene);
                   // using .png :
                   /*
                   var colorGradingTexture = new BABYLON.Texture("textures/colorGrade-highContrast.png", scene, true, false);
                   colorGradingTexture.wrapU = BABYLON.Texture.CLAMP_ADDRESSMODE;
                   colorGradingTexture.wrapV = BABYLON.Texture.CLAMP_ADDRESSMODE;                
                   defaultPipeline.imageProcessing.colorGradingTexture = colorGradingTexture;
                   defaultPipeline.imageProcessing.colorGradingWithGreenDepth = false;
                   */
               }
               /* color curves */
               defaultPipeline.imageProcessing.colorCurvesEnabled = false; // false by default
               if (defaultPipeline.imageProcessing.colorCurvesEnabled) {
                   var curve = new BABYLON.ColorCurves();
                   curve.globalDensity = 0; // 0 by default
                   curve.globalExposure = 0; // 0 by default
                   curve.globalHue = 30; // 30 by default
                   curve.globalSaturation = 0; // 0 by default
                   curve.highlightsDensity = 0; // 0 by default
                   curve.highlightsExposure = 0; // 0 by default
                   curve.highlightsHue = 30; // 30 by default
                   curve.highlightsSaturation = 0; // 0 by default
                   curve.midtonesDensity = 0; // 0 by default
                   curve.midtonesExposure = 0; // 0 by default
                   curve.midtonesHue = 30; // 30 by default
                   curve.midtonesSaturation = 0; // 0 by default
                   curve.shadowsDensity = 0; // 0 by default
                   curve.shadowsExposure = 0; // 0 by default
                   curve.shadowsHue = 30; // 30 by default
                   curve.shadowsDensity = 80;
                   curve.shadowsSaturation = 0; // 0 by default;
                   defaultPipeline.imageProcessing.colorCurves = curve;
               }
           }
           /* DOF */
           defaultPipeline.depthOfFieldEnabled = false; // false by default
           if (defaultPipeline.depthOfFieldEnabled && defaultPipeline.depthOfField.isSupported) {
               defaultPipeline.depthOfFieldBlurLevel = 0; // 0 by default
               defaultPipeline.depthOfField.fStop = 1.4; // 1.4 by default
               defaultPipeline.depthOfField.focalLength = 50; // 50 by default, mm
               defaultPipeline.depthOfField.focusDistance = 2000; // 2000 by default, mm
               defaultPipeline.depthOfField.lensSize = 50; // 50 by default
           }
           /* FXAA */
           defaultPipeline.fxaaEnabled = false; // false by default
           if (defaultPipeline.fxaaEnabled) {
               defaultPipeline.fxaa.samples = 1; // 1 by default
               defaultPipeline.fxaa.adaptScaleToCurrentViewport = false; // false by default
           }
           /* sharpen */
           defaultPipeline.sharpenEnabled = true;
           if (defaultPipeline.sharpenEnabled) {
               defaultPipeline.sharpen.adaptScaleToCurrentViewport = false; // false by default
               defaultPipeline.sharpen.edgeAmount = 0.2; // 0.3 by default
               defaultPipeline.sharpen.colorAmount = 1; // 1 by default
           }
       }


       // Add a directional light
       var directionalLight = new BABYLON.DirectionalLight("directionalLight", new BABYLON.Vector3(1.70, 1.50, 1.60), scene);
       directionalLight.position = new BABYLON.Vector3(1.7, 1.5, 1.6); // Position is relevant for shadow calculations
       directionalLight.intensity = 5; // Adjust as needed
       directionalLight.parent = camera;

       // Set up light
       //var light = new BABYLON.HemisphericLight("light", new BABYLON.Vector3(0, 5, 0), scene);
       //light.intensity = 1;
       //light.parent = camera;

       //var pointLight = new BABYLON.PointLight("pointLight", new BABYLON.Vector3(0, 20, 0), scene);
       //pointLight.intensity = .5;
       //pointLight.range = 100;
       //pointLight.parent = camera;


       // Define the crystal material
       var crystalMaterial = new BABYLON.PBRMaterial("crystalMaterial", scene);
       crystalMaterial.subSurface.isRefractionEnabled = false;
       crystalMaterial.subSurface.refractionIntensity = 1;
       //crystalMaterial.subSurface.useAlbedoToTintRefraction = 1;
       crystalMaterial.subSurface.indexOfRefraction = 1.2;
       //crystalMaterial.subSurface.thicknessTexture = 1;
       //crystalMaterial.subSurface.linkRefractionWithTransparency = 1;
       //crystalMaterial.linkRefractionWithTransparency = true;
       //crystalMaterial.indexOfRefraction = 1.05;
       crystalMaterial.metallic = 0;
       crystalMaterial.roughness = 0;
       //crystalMaterial.invertRefractionZ = true;
       //crystalMaterial.alpha = 0.9;
       //crystalMaterial.diffuseColor = new BABYLON.Color3(1, 0.5, 0.5);
       crystalMaterial.directIntensity = 0.5;
       crystalMaterial.environmentIntensity = 1;
       //crystalMaterial.cameraExposure = 0.66;
       //crystalMaterial.cameraContrast = 1.66;
       crystalMaterial.microSurface = 1;
       //crystalMaterial.backFaceCulling = false;
       crystalMaterial.reflectionTexture = envTexture;
       //crystalMaterial.separateCullingPass = true;



       var engraving_mesh, crystalMesh, duplicateCrystalMesh;
       var refractionTexture;
       // Global variable to hold the UCX cylinder
       var ucx_cylinder;

       let isFirstTime = true;

       function crystal_loaded() {
           adjustCameraRadius(cameraClone, ucx_cylinder, engine)
           console.log('Updated lower limit:', cameraClone.lowerRadiusLimit);
           var keys = [{
               frame: 20,
               value: 30
           }, {
               frame: 100,
               value: cameraClone.lowerRadiusLimit
           }];
           console.log("is the value correct?", cameraClone.lowerRadiusLimit)
           flyInAnimation.setKeys(keys);
           if (isFirstTime) {
               // Attach the fly-in animation to the camera and start it
               camera.animations.push(flyInAnimation);
               scene.beginDirectAnimation(camera, [flyInAnimation], 0, 100, false, 1, () => {
                   // Set camera radius limits and start idle rotation after animation
                   setCameraRadiusLimits();
                   startIdleRotation();
               });

               // Set the flag to false so this block won't be executed again
               isFirstTime = false;
           } else {
               setCameraRadiusLimits();

           }
       };


       // Function to create a cylindrical collision volume
       function createUCXCylinder(mesh) {
           mesh.computeWorldMatrix(true);
           mesh.refreshBoundingInfo();

           var boundingBox = mesh.getBoundingInfo().boundingBox;
           var center = boundingBox.centerWorld;

           // Calculate the necessary radius and height
           var height = boundingBox.maximumWorld.y - boundingBox.minimumWorld.y;

           // Find the furthest horizontal distance from the center to a corner in the XY plane
           var corner = new BABYLON.Vector3(boundingBox.maximumWorld.x, center.y, boundingBox.maximumWorld.z);
           var radius = BABYLON.Vector3.Distance(corner, new BABYLON.Vector3(center.x, center.y, center.z));

           // Create the cylinder
           ucx_cylinder = BABYLON.MeshBuilder.CreateCylinder("ucx_cylinder", {
               height: height,
               diameter: 2 * radius // Diameter is twice the radius
           }, mesh.getScene());

           ucx_cylinder.position = center;
           ucx_cylinder.visibility = 0; // Typically set to 0 for invisible collision meshes
           ucx_cylinder.isPickable = false; // Set to false if it's only for calculations

           return ucx_cylinder;
       };


       function removeUCXCylinder() {
           if (ucx_cylinder) {
               ucx_cylinder.dispose(); // This will remove the cylinder from the scene
               ucx_cylinder = null; // Clear the reference
           }
       };




       // Function to load a mesh
       function load_crystal(url, onSuccess) {
           BABYLON.SceneLoader.ImportMesh("", baseUrl, url, scene, function(newMeshes) {

               newMeshes.forEach(function(mesh) {

                   mesh.scaling.scaleInPlace(5);
                   createUCXCylinder(mesh);


                   if (mesh.material && mesh.material instanceof BABYLON.PBRMaterial) {
                       mesh.material = crystalMaterial;
                       crystalMesh = mesh;
                       isMeshLoaded2 = true;
                       isMeshLoaded = true;
                       crystal_loaded();
                       console.log(crystal_loaded);
                       onSuccess(crystalMesh);
                       setupRefractionIfNeeded();

                       //duplicate mesh and mat
                       duplicateCrystalMesh = crystalMesh.clone("duplicateCrystalMesh");
                       var duplicateMaterial = new BABYLON.PBRMaterial("duplicateMaterial", scene);
                       duplicateMaterial.directIntensity = 0.5;
                       duplicateMaterial.backFaceCulling = false;
                       duplicateMaterial.depthFunction = BABYLON.Engine.NOTEQUAL;
                       //duplicateMaterial.needDepthPrePass = true;
                       //duplicateMaterial.separateCullingPass = true;
                       duplicateCrystalMesh.material = duplicateMaterial;
                       duplicateMaterial.reflectionTexture = envTexture;
                       //duplicateCrystalMesh.layerMask = 2;
                       duplicateMaterial.alpha = 0; //Do not change, inside visibility of crystal


                   }




               });


           });
       }


       // Function to replace the current mesh
       function replace_crystal(newUrl) {
           if (crystalMesh) {
               removeUCXCylinder();
               crystalMesh.dispose(); // Dispose of the current mesh

           }

           if (duplicateCrystalMesh) {
               duplicateCrystalMesh.dispose();
           }


           load_crystal(newUrl, function(loadedMesh) {
               console.log("New crystal_mesh loaded and replaced successfully.");
               // Additional setup for the new mesh if required
               //setupRefractionIfNeeded();

           });
       }

       // Initial mesh load
       load_crystal(crystal, function(loadedMesh) {
           console.log("Initial crystal_mesh loaded.");
           let preview_buttons = document.querySelector('.preview-crystals__buttons');
           if (preview_buttons) {
               preview_buttons.classList.remove('hide');
           }
           // Initial setup or manipulations
       });

       // Example usage: Replace the mesh on some event or condition
       //setTimeout(function() {
       //replace_crystal(new_crystal); // Replace the mesh after a delay
       //}, 10000); // 10 seconds later




       function load_engraving(url, onSuccess) {
           BABYLON.SceneLoader.ImportMesh("", baseUrl, url, scene, function(newMeshes) {
               // Scale each imported mesh as soon as they are loaded
               newMeshes.forEach(function(mesh) {
                   engraving_mesh = mesh;
                   engraving_mesh.scaling.scaleInPlace(5); // Scale each mesh by 10

                   if (mesh.material && mesh.material instanceof BABYLON.PBRMaterial) {
                       // Make engraving_mesh invisible to the camera but still rendered for refraction
                       engraving_mesh.layerMask = 2;
                       isMeshLoaded = true;

                       let meshMaterial = mesh.material;
                       meshMaterial.needDepthPrePass = true;
                       meshMaterial.transparencyMode = BABYLON.PBRMaterial.PBRMATERIAL_ALPHABLEND;
                       meshMaterial.alphaMode = BABYLON.Engine.ALPHA_PREMULTIPLIED;
                       meshMaterial.useAlphaFromAlbedoTexture = true;
                       meshMaterial.albedoColor = new BABYLON.Color3(230 / 255, 230 / 255, 230 / 255);
                       meshMaterial.emissiveColor = new BABYLON.Color3(0.9, 0.9, 0.9); // Pure white

                       // Check if the mesh has a material and textures
                       if (engraving_mesh.material && engraving_mesh.material.getActiveTextures()) {
                           textures = engraving_mesh.material.getActiveTextures();
                           textures.forEach((texture) => {
                               texture.level = 2;

                               texture.hasAlpha = true;
                               texture.useAlphaFromAlbedoTexture = true;
                               setupRefractionIfNeeded();
                           });
                       }
                   }
               });
           });
       }


       // Function to replace the current mesh
       function replace_engraving(newUrl) {
           if (engraving_mesh) {
               engraving_mesh.dispose(); // Dispose of the current mesh

           }


           load_engraving(new_engraving, function(loadedMesh) {
               console.log("New mesh loaded and replaced successfully.");
               // Additional setup for the new mesh if required
           });
       }

       // Initial mesh load
       load_engraving(engraving, function(loadedMesh) {
           console.log("Initial engraving_mesh loaded.");
           // Initial setup or manipulations
       });




       // Now adjust the camera's layerMask
       camera.layerMask = 1;
       var refraction = false;

       function setupRefractionIfNeeded() {
           // Ensure both meshes are loaded and refraction texture is only setup once


           var refractionTexture = new BABYLON.RefractionTexture("th", 1024, scene);
           refractionTexture.renderList.push(engraving_mesh);
           refractionTexture.renderList.push(plane); // Evaluate if this is needed based on your scene setup
           refractionTexture.refractionPlane = new BABYLON.Plane(0, 0, 0, -3);
           crystalMaterial.refractionTexture = refractionTexture;

       }

       scene.registerBeforeRender(function() {
           if (isMeshLoaded && refractionTexture && refractionTexture.refractionPlane) { // Ensure 'dog' is defined before accessing it

               // Adjust refraction based on camera or scene changes
               const dir = camera.getForwardRay().direction;

               refractionTexture.refractionPlane.normal.x = -dir.x;
               refractionTexture.refractionPlane.normal.z = -dir.z;
               refractionTexture.refractionPlane.normal.normalize();
               refractionTexture.refractionPlane.d = -BABYLON.Vector3.Dot(engraving_mesh.position, refractionTexture.refractionPlane.normal) - 3;
               //console.log("GreenspherePosition:", greenSphere.position);


           }

       });

       // Create a button element
       let button = document.querySelectorAll(".preview-crystal__image button");

       // Add an event listener for the 'click' event
       button.forEach(function(e) {
           e.addEventListener("click", function() {
               console.log("Button was clicked");
               //showBoundingBox(ucx_cylinder); 
               //adjustCameraRadius(cameraClone, ucx_cylinder, engine);
               //setCameraRadiusLimits();
               let buttonArray = Array.from(button);
               buttonArray.forEach(function(element) {
                   element.classList.remove("active");
               });
               this.classList.add('active');
               let new_crystal = this.getAttribute("data-image");
               if (new_crystal) {
                   replace_crystal(new_crystal); // Call the replace_crystal function
                   if (isMeshInView(cameraClone, ucx_cylinder, engine)) {
                       console.log("The mesh is fully in view.");

                   } else {
                       console.log("Part of the mesh is out of view.");
                   }
               }
           });
       })


       // Listen for canvas size changes
       // window.addEventListener('resize', function() {
       //updateCameraRadiusLimits();
       //setCameraRadiusLimits();
       //adjustCameraRadius(scene.activeCamera, ucx_cylinder, engine)
       // });


       // Listen for canvas size changes
       var resizeTimer; // Timer to track end of resizing
       window.addEventListener('resize', function() {
           clearTimeout(resizeTimer); // Clear the timer on each resize event

           // Set a new timer
           resizeTimer = setTimeout(function() {
               adjustCameraRadius(cameraClone, ucx_cylinder, engine);
               console.log("AdjustCameraRadius called after resizing has stopped.");
           }, 250); // Delay


       });




       function isMeshInView(camera, mesh, engine, innerMargin, outerMargin) {


           let vertices = mesh.getVerticesData(BABYLON.VertexBuffer.PositionKind);
           let isInView = false;
           let Bounds = {
               horizontal: false,
               vertical: false,
               InnerHorizontal: true,
               InnerVertical: true
           };

           if (vertices) {
               let viewport = camera.viewport.toGlobal(engine.getRenderWidth(), engine.getRenderHeight());
               let viewMatrix = camera.getViewMatrix();
               let projectionMatrix = camera.getProjectionMatrix();
               let worldViewProjection = viewMatrix.multiply(projectionMatrix);

               // Outer margin calculations
               let outerHorizontalMin = viewport.width * outerMargin;
               let outerHorizontalMax = viewport.width * (1 - outerMargin);
               let outerVerticalMin = viewport.height * outerMargin;
               let outerVerticalMax = viewport.height * (1 - outerMargin);

               // Inner margin calculations
               let innerHorizontalMin = viewport.width * innerMargin;
               let innerHorizontalMax = viewport.width * (1 - innerMargin);
               let innerVerticalMin = viewport.height * innerMargin;
               let innerVerticalMax = viewport.height * (1 - innerMargin);

               // Iterate through each vertex to check its position relative to the viewport and margins
               for (let i = 0; i < vertices.length; i += 3) {
                   let vertex = BABYLON.Vector3.FromArray(vertices, i);
                   vertex = BABYLON.Vector3.TransformCoordinates(vertex, mesh.getWorldMatrix());
                   let screenPos = BABYLON.Vector3.Project(
                       vertex,
                       BABYLON.Matrix.IdentityReadOnly,
                       worldViewProjection,
                       viewport
                   );

                   // Outer margin checks
                   if (screenPos.x < outerHorizontalMin || screenPos.x > outerHorizontalMax) {
                       Bounds.horizontal = true;
                   }
                   if (screenPos.y < outerVerticalMin || screenPos.y > outerVerticalMax) {
                       Bounds.vertical = true;
                   }

                   // Inner margin checks
                   if (screenPos.x < innerHorizontalMin || screenPos.x > innerHorizontalMax) {
                       Bounds.InnerHorizontal = false;
                   }
                   if (screenPos.y < innerVerticalMin || screenPos.y > innerVerticalMax) {
                       Bounds.InnerVertical = false;
                   }

                   // If the mesh is within the outer margins and not marked as out of bounds
                   if (screenPos.x >= outerHorizontalMin && screenPos.x <= outerHorizontalMax &&
                       screenPos.y >= outerVerticalMin && screenPos.y <= outerVerticalMax) {
                       isInView = true;
                   }
               }
           }

           console.log("Mesh is in view:", isInView, "Out of bounds:", Bounds);
           console.log('Updated lower limit:', cameraClone.lowerRadiusLimit);
           return {
               isInView: isInView,
               Bounds: Bounds,
               isTooSmall: Bounds.InnerHorizontal && Bounds.InnerVertical
           };
       }




       function adjustCameraRadius(camera, mesh, engine, innerMargin = 0.1, outerMargin = 0.05, maxIterations = 10) {
           let iterationCount = 0;
           let adjustmentNeeded = false;

           do {
               // Force camera and scene updates to ensure new settings are applied
               camera.getScene().updateTransformMatrix();

               const visibility = isMeshInView(camera, mesh, engine, innerMargin, outerMargin);
               console.log(`Iteration ${iterationCount}, Visibility:`, visibility);

               if (!visibility || typeof visibility.Bounds === 'undefined') {
                   console.log("Error: visibility data is incomplete or undefined!");
                   break;
               }

               adjustmentNeeded = false; // Reset flag at the start of each iteration

               if (visibility.Bounds.horizontal || visibility.Bounds.vertical) {
                   camera.lowerRadiusLimit *= 1.1;
                   camera.upperRadiusLimit *= 1.1;
                   adjustmentNeeded = true;
                   console.log('Radius increased to prevent mesh from being cut off.');
               } else if (visibility.Bounds.InnerHorizontal && visibility.Bounds.InnerVertical) {
                   camera.lowerRadiusLimit *= 0.9;
                   camera.upperRadiusLimit *= 0.9;
                   adjustmentNeeded = true;
                   console.log('Radius decreased as mesh is too small.');
               } else if (!visibility.Bounds.horizontal && !visibility.Bounds.vertical &&
                   (!visibility.Bounds.InnerHorizontal && !visibility.Bounds.InnerVertical)) {
                   console.log('No adjustment needed; mesh positioning within acceptable bounds.');

               } else {
                   console.log('Mesh positioning is optimal on one axis; no radius adjustment needed.');

               }

               camera.radius = clamp(camera.radius, camera.lowerRadiusLimit, camera.upperRadiusLimit);
               iterationCount++; // Increment iteration count
           } while (adjustmentNeeded && iterationCount < maxIterations);

           if (iterationCount >= maxIterations) {
               console.log(`Max iterations reached (${maxIterations}); may require manual adjustment.`);
           }
       }

       function clamp(value, min, max) {
           return Math.max(min, Math.min(value, max));
       }




       function showBoundingBox(mesh) {
           // Enable the bounding box display
           mesh.showBoundingBox = true;

           // Optionally, to enhance visibility, customize the bounding box color
           if (!mesh.getScene().getBoundingBoxRenderer()) {
               mesh.getScene().getBoundingBoxRenderer().frontColor = new BABYLON.Color3(1, 0, 0); // Red
           } else {
               mesh.getScene().getBoundingBoxRenderer().frontColor = new BABYLON.Color3(1, 0, 0); // Set to red or any other color
           }
       }




       //setupUserInteraction();

       return scene;
   };
   var scene = createScene();

   engine.runRenderLoop(function() {
       scene.render();
   });

   // Resize the engine on window resize
   window.addEventListener('resize', function() {
       engine.resize();
   });
});
